import { Fragment } from 'react'
import Carousel from '../new-carousel'

import { Box } from '../../../../shared_components/UI/Box'
import { Card, CardProps } from './Card'
import UpcomingPoolLoadingState from '../LoadingStates/Upcoming'
import { CardsWrapper, DesktopView, MobileView } from './styles'
import { v4 as uuidv4 } from 'uuid'

interface Props {
  cards: CardProps[]
  isHardcoded?: boolean
}

const ProjectCards = ({ cards, isHardcoded }: Props) => {
  const getProjectCards = (limit?: number) =>
    cards.length > 0
      ? cards.map((card, index) => {
          if (!limit || index < limit) {
            return (
              <Card {...card} key={uuidv4()} isHardcoded={card.isHardcoded} />
            )
          } else {
            return null
          }
        })
      : Array(4)
          .fill(null)
          .map((_, i) => <UpcomingPoolLoadingState key={uuidv4()} />)

  return (
    <>
      <DesktopView>
        {cards.length > 0 ? (
          <CardsWrapper>{getProjectCards(8)}</CardsWrapper>
        ) : (
          <Box>{getProjectCards(8)}</Box>
        )}
      </DesktopView>
      <MobileView>
        <Carousel items={getProjectCards()} cardWidth={290} />
      </MobileView>
    </>
  )
}

export default ProjectCards
